import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { MOBILE_BREAKPOINT, rydeColors } from "@ryde/theme";

import { KANBAN_CARD_WIDTH } from "../common";

const CARD_BOARD_VIEWPORT_HEIGHT_OFFSET = "162px";

export const RidesCardBoardStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "rides-card-board",
})<{ $leftColumn: number }>`
  padding-top: 20px;
  display: grid;
  height: calc(100vh - ${CARD_BOARD_VIEWPORT_HEIGHT_OFFSET});
  width: 100%;
  min-width: 0;
  grid-template-columns: ${props => props.$leftColumn}% ${props =>
      100 - props.$leftColumn}%;
  grid-template-rows: 1fr;
  min-height: 0;
  padding-inline-start: 20px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-inline-start: 12px;
    padding-inline-end: 12px;
  }

  .CardBoardNoData {
    font-size: 24px;
    align-content: center;
    text-align: center;
    color: ${rydeColors.grey};
  }

  .drag_over .CardBoardItem {
    outline: 3px solid ${rydeColors.dragBorderColor};
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  }
  .drag_not_allowed {
    opacity: 0.3;
  }

  .card-board-left-column {
    min-height: 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .card-board-scroll-shell {
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
    overflow-y: auto;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      overflow-x: auto;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
  }

  .card-board-list {
    @media (max-width: ${MOBILE_BREAKPOINT}) {
      width: max-content;
      min-width: 100%;
    }
  }

  .CardBoardItem {
    @media (max-width: ${MOBILE_BREAKPOINT}) {
      width: ${KANBAN_CARD_WIDTH}px;
      max-width: none;
    }
  }

  .card-board-map-wrapper {
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    min-height: 0;
    min-width: 0;
    height: 100%;
    overflow: hidden;

    .map_scrollable_content {
      min-width: max(100%, 250px);
      height: 100%;
      flex: 1;
      min-height: 0;
      overflow-x: auto;
    }
  }
`;
